<template>

  <div id="activation">
    <div class="row">
            <div class="large-12 medium-12 small-12 columns"><p></p>
              <h2 class="pcg-title" v-html="currPkg.readable"></h2>
              <hr>
            <div  v-if="baseView.addInfo && !states.isDirect">
              <div v-html="currPkg.desc.longText"></div><p></p>
              <div v-html="infoText"></div>
              <div v-html="valText"></div>
              <div v-html="price"></div>
              <div v-if="currPkg.prolongable && !currPkg.isActive">
                <br/><p v-html="tpl('package.prolongInfo')"></p>
              </div>
              <p>&nbsp;</p>
              <p v-html="tpl('package.denyNew')" v-if="!currPkg.isActive && baseView.majorActive" v-bind:class="{ cState: baseView.majorActive }"></p>
            <a class="actions action" v-if="!currPkg.isActive && !baseView.majorActive" v-on:click = "callAction('start')">AKTIVOVAŤ</a>                        
            <a class="actions action" v-if="currPkg.isActive && currPkg.addon" v-on:click = "callAction('addon')" v-html="currPkg.desc.addonBtn"></a>                        
            <a class="actions action" v-if="currPkg.isActive && currPkg.paralellPack" v-on:click = "callAction('start')" v-html="(currPkg.desc.paralelBtn + ' ' + moment(productdetail.timeStamp).add(currPkg.paralellDaysAdd, 'days').format('D.M.YYYY')) || 'ZNOVU AKTIVOVAŤ A PREDĹŽIŤ PLATNOSŤ'"></a>                        
            <a class="actions action" v-if="currPkg.hasNext" v-on:click = "callAction('stopProl')">VYPNÚŤ AUTOMATICKÉ PREDĹŽENIE</a>      
            <a class="actions action" v-if="currPkg.isActive" v-on:click="states.mainView = true, states.activationsView = false">NÁVRAT NA PREHĽAD</a>                        
          </div>

          <div  v-if="baseView.voiceBq">
            <div v-show="baseView.newNrAllowed" class="pcg_new">
              <p><span v-html="tpl('package.voicePkgNewNumber')"></span></p>
              <input type="text" v-model="voicePkgMsisdn" placeholder="09" v-bind:class="{ check_ok: checkOk }">
              <div><span v-if="!baseView.nrExists">Platí do <strong><span v-html="newPcgVal()"></span></strong></span><span class="cState" v-if="baseView.nrExists">Pre zadané tel. číslo je služba už aktívna.</span></div>
              <a class="actions action"  v-bind:class="{ check_fail: !checkOk }" v-on:click="callAction('start'), baseView.voiceBq = false">Aktivovať</a>
              
            </div>
          <span v-if="currPkg.numSorted" class="fet">AKTUÁLNE NASTAVENIE</span>
          <div v-for="fnfNr in currPkg.numSorted" :key="fnfNr.name" class="row">
          <div class="large-12 medium-12 small-12 columns"><hr/>
                <span class="inline fet">Volania na {{ formatMsisdn(fnfNr.benefitMsisdn) }}</span>
            </div>
            <div class="large-12 medium-12 small-12 columns xspace">
                <span class="inline">Platnosť</span>
                <span class="right" v-html="moment(fnfNr.endDate || fnfNr.nextChargeDate).format('D.M.YYYY H:mm')"></span>
            </div>
            <div class="large-12 medium-12 small-12 columns">
                <span class="inline">Automatické predĺženie</span>
                <span class="right" v-html="fnfNr.fnfPkgProlTxt"></span>
                <a class="actions action" v-if="fnfNr.fnfPkgProl" v-on:click="currPkg['stopProl'].fnfExt = (fnfNr.benefitMsisdn || ''), callAction('stopProl'), baseView.voiceBq = false">Vypnúť automatické predĺženie</a>                        
            </div>
          </div>
        <p></p>
          </div>
            </div>
            <div class="large-12 medium-12 small-12 columns" v-if="baseView.addTYPage">
              <p v-html="baseView.TYText" v-bind:class="{ mActive: baseView.TYInfoAlert }"></p><p>&nbsp;</p>
                <a class="actions action" v-on:click="actionRel()" v-if="baseView.TYBtn">NÁVRAT NA PREHĽAD</a>
            </div>
        </div>      
       </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'activations',
  props: ['productdetail', 'tplData', 'states', 'pkgDef', 'nextPacks'],
  data () {
    return {
      msg: 'Aktivácie',
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      fromTpl: {

      },
      baseView: {
        add200: false, pBar: true, pgPercentage: 0, pgVal: '', addToGiga: false, stopProlong: false, pgLeftText: "Internet", prolState: "zapnuté",
        prolVisible: false, bucketRest: "0 MB", hasMoreData: false, nextPacks: [], addTextGiga: "Dokúpiť 500 MB za 1 €", addInfo: true, addTYPage: false, TYBtn: false, TYText: '', TYInfoAlert: false, majorActive: false, voiceBq: false, newNrAllowed: true, nrExists: false   
      },
      namesMap: {"GIGA1W":"Raz Giga", "GIGA1M":"Vždy Giga", "GIGA2":"Vždy 2 Giga", "StreamOn Data Unlmtd":"Stream On", "StreamOn Data 200":"Stream On 200 MB", "GIGA6":"Dáta na rok 6GB", "GIGA24":"Dáta na rok 24GB", "GIGADEN":"Giga Deň",
      "SW Data":"Dáta pre blízkych", "Magenta Data":"Darované dáta z Magenta 1", "Promo Data":"Daruj a dostaneš", "GIGAZIMNY":"Giga akcia"},
      voicePkgMsisdn: "",
      moment: moment
    }
  },
  created: function() {
    var that = this
    window.history.pushState(null, '')
    window.onpopstate = function(event) {
    window.history.replaceState(null, '')
    that.states.mainView = true 
    that.states.activationsView = false
    }

    this.states.mainView = false

    if (this.states.isDirect) {
      this.baseView.addInfo = false
      if (this.currPkg.bucketName == "FreeCalls2Num")  {
        this.baseView.voiceBq = true

      } else {
        this.baseView.addTYPage = true
        this.callAction(this.states.directAction)
      }
    }
  },
  mounted: function() {
    if (this.currPkg.bucketName == "GIGA1M") {
      if (!_.isEmpty(_.filter(this.nextPacks, { 'buckets': {name: "GIGA2"} }))){
        this.baseView.majorActive = true
      }      
    }
    if (this.currPkg.bucketName == "GIGA1W") {
      if ((!_.isEmpty(_.filter(this.nextPacks, { 'buckets': {name: "GIGA1M"} }))) || (!_.isEmpty(_.filter(this.nextPacks, { 'buckets': {name: "GIGA2"} })))) {
        this.baseView.majorActive = true
      }      
    }
  },
  computed: {
    readMsisdn: function() {
      if (String(this.productdetail.msisdn).length > 8) {
        return '0' + String(this.productdetail.msisdn).substring(3)
      }
      else {
        return ''
      }
    },
    currPkg: function() {
      if (this.states.pkgAction === 'worryFree') {
        this.states.directAction = 'start';
        res = this.states.currPkg;
      } else {
        var res = _.filter(this.pkgDef, { 'bucketName': this.states.pkgAction})[0]
        var that = this

        if (!_.isEmpty(res.numSorted)) {
          _.forEach(res.numSorted, function(pv, pk){
            if ((pv.nextChargeDate) && (moment(pv.nextChargeDate) > moment(that.productdetail.timeStamp))) {
            pv.fnfPkgProlTxt = "zapnuté"
            pv.fnfPkgProl = true
            } else {
            pv.fnfPkgProlTxt = "vypnuté"
            pv.fnfPkgProl = false
            }
          })
          if (res.numSorted.length > 4) {
            that.baseView.newNrAllowed = false
          }
        }
      }
      return res
    },
    infoText: function() {
      var res = this.currPkg.desc.infoText
      var resObj = res.split('bjem:')
      if (resObj[1]) {
        resObj[1] = "<strong>" + resObj[1]
        res = resObj.join('bjem:') + "</strong>"
      } else if (resObj.length === 1) {
        res = "<strong>"+res+"</strong>"
      }
      return res
    },
    valText: function() {
      var res = this.currPkg.desc.valText
      var resObj = res.split('latnosť:')
      if (resObj[1]) {
        resObj[1] = "<strong>" + resObj[1]
        res = resObj.join('latnosť:') + "</strong>"
      }
      return res
    },
    price: function() {
      return "Cena: <strong>"+parseFloat(this.currPkg.price).toFixed(2).toString().replace(/\./, ',')+" €</strong>"
    },
    checkOk: function() {
      var virgin = this.voicePkgMsisdn.replace(/ /g, '')
      if ((virgin.length >= 9) && (!isNaN(virgin)) && ((virgin.substr(virgin.length - 9, 1) == '9'))) {
        this.currPkg['start'].fnfExt = "421" + virgin.substr(virgin.length - 9)
        var that = this
        _.forEach(this.currPkg.numSorted, function(sv){
          if (String(sv.value) == that.currPkg['start'].fnfExt) {
            that.baseView.nrExists = true
          }
        })
        return true 
      } else {
        this.baseView.nrExists = false
        return false
      }
    },
    isProd: function() {
      if ((window.location.hostname == "m.telekom.sk") && (this.$store.state.activeAnalytic)) {
        return true
      } else {
        return false
      }
    }
  }, 
  methods: {
    callAction: function(fAction) {
      var that = this, ext2 = 'mweb'
      if (that.currPkg[fAction].commandName == "FreeCalls21N") {
        ext2 = that.currPkg[fAction].fnfExt.toString()
      }
      if (this.states.pkgAction === 'Mixi' && this.states.directAction === 'stopProl') {
        this.currPkg[fAction].commandName = this.states.mixiProl.commgroup; 
        this.currPkg[fAction].commandType = this.states.mixiProl.deactCommand; 
      }
      this.baseView.addTYPage = true, this.baseView.addInfo = false, this.baseView.TYText = this.tplData.credit.httpCallWait, this.baseView.TYInfoAlert = false
      this.$http.put('/pb/easy-api/packages', { name: that.currPkg[fAction].commandName, ext: [that.currPkg[fAction].commandType, ext2] })
        .then(function (resp) {
            that.baseView.TYText = that.tplData.credit.httpCallSuccess
            if(that.currPkg.bucketName === "WFOFF") {
              that.baseView.TYText = that.tplData.credit.httpCallFinish
            }
            that.$store.dispatch('refreshProductDetail')
            if ((fAction == 'start') && (that.isProd)) {
              var dlName = that.currPkg[fAction].commandName + '_' + that.currPkg[fAction].commandType
              dataLayer.push({
                'event': 'purchase',
                'ecommerce': {
                  'purchase': {
                    'actionField': {
                      'id': new Date().getTime().toString(), 
                      'affiliation': 'm.telekom',
                      'revenue': that.currPkg.price
                    },
                    'products': [{
                      'name': dlName,  
                      'id': 'SC0001',
                      'price': that.currPkg.price,
                      'brand': 'm.telekom',
                      'category': 'VAS',
                      'quantity': 1
                    }]
                  }
                }
              });                 
            }
        })
        .catch(function(error){
          var resText = that.tplData.credit.httpCallFail
          if (error.response.status === 403 && location.hostname !== 'localhost') {
            window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
          } else {
            that.baseView.TYInfoAlert = true
            try {
                if ((error.response.data.message).indexOf('NOK-Insufficient credit') != -1) {
                    resText = that.tplData.package.denyNoCredit
                }
                if ((error.response.data.message).indexOf('NOK-not allowed') != -1) {
                    resText = that.tplData.package.denyNewHttpCall
                }
                if ((error.response.data.message).indexOf('Not Acceptable') != -1) {
                    resText = that.tplData.package.denyNewHttpCall
                }
                if ((error.response.data.message).toLowerCase().indexOf('no response from') != -1) {
                    that.baseView.TYInfoAlert = false
                    resText = "Požiadavka bola odoslaná, výsledok spracovania potvrdíme SMS správou."
                    that.$store.dispatch('refreshProductDetail')
                }
                if (that.currPkg[fAction].commandName == "FreeCalls21N") {
                  if ((error.response.data.message).indexOf('NOK-MAXNUM reached') != -1) {
                      resText = "Aktivácia nieje možná. Dosiahnutý maximálny počet telefónnych čísel pre zľavu."
                  }
                  if ((error.response.data.message).indexOf('NOK-Magenta1 FnF match') != -1) {
                      resText = that.tplData.package.denyVoiceMagenta
                  }
                  if ((error.response.data.message).indexOf('NOK-DeactNonExistNum') != -1) {
                      resText = that.tplData.package.denyVoiceDeact
                  }
                }
            }
            catch(e) {}
            that.baseView.TYText = resText
          }
        })
        .finally(function() {
          that.baseView.TYBtn = true
        })
    },
    actionRel: function()  {
      // this.states.mainView = true
      // this.states.activationsView = false,
      this.states.viewAllow = false
      this.states.activationsView = false
      location.reload()
    },
    formatMsisdn: function(virgin) {
      return '0' + String(virgin || '').substr(-9)
    },
    newPcgVal: function() {
      return this.states.daysAcc[(moment(this.productdetail.timeStamp).add((this.currPkg.paralellDaysAdd || 0), 'days').format('d'))] + ', ' + moment(this.productdetail.timeStamp).add((this.currPkg.paralellDaysAdd || 0), 'days').format('D.M.YYYY H:mm')
    }
  }
}
</script>

<style scoped>
input[type=number], input[type=text] {
  margin-left: 0px;
  height: 50px;
  font-size: 1.5em;
  line-height: 50px;  
  background-color: #ededed;
  padding: 0 10px;
}

input.check_ok {
  border-bottom: 2px solid #6bb324;
}
a.check_fail {
  pointer-events: none;
  color: #383838;;
  border: 2px solid  #a4a4a4;
  background-color: #ededed;
  font-weight: 400;
}

a {
  text-decoration: none;
}

a.pcg-btm {
  text-decoration: underline;
}

.pcg-title {
  text-transform: uppercase;
}

.cState {
  color: #e20074;
  font-weight: bold;
}

.pcg_new {
  margin-bottom: 3rem;
}
</style>
